// @theme component
import React from 'react';
import style from '@theme/js/components/main/SmsVerification/index.scss';
import { SmsVerificationStepType } from '@theme/js/components/main/SmsVerification/';
import { STEPS_NAME } from '@theme/js/components/main/SmsVerification/constants';
import { useTranslations } from '@core/js/hooks/i18n';
import { clsx } from '@core/js/utils/classNames.util';

const ServiceUnavailableStep = React.memo(({ setStep }: SmsVerificationStepType) => {
    const t = useTranslations('playtech.mobile.system.verification.serviceUnavailable.');

    return (
        <>
            <div className={clsx([style.icon, style.serviceUnavailableIcon])}></div>
            <div className={style.message}>{t('message')}</div>
            <div className={style.description}>
                {t('description')}
            </div>
            <div className={style.phoneNumber}>{t('message2')}</div>
            <button onClick={() => setStep?.(STEPS_NAME.INITIAL)} className={style.verificationButton}>
                {t('submit')}
            </button>
        </>
    );
});

export default ServiceUnavailableStep;
